import StepProgress from './StepProgress.view';

export default StepProgress;
